(function (){
    'use strict';

    angular
        .module('services')
        .service('GeneralReportsService', GeneralReportsService);

    GeneralReportsService.$inject = ['$http', 'API_BASE'];

    function GeneralReportsService ($http, API_BASE) {
        var service = this;

        // service.getByFilterExhibitors = getByFilterExhibitors;
        //
        // function getByFilterExhibitors (query) {
        //     return $http.get(API_BASE + '/physicalfairs/reports/exhibitors',{params:query});
        // }

        service.getExhibitors               = getExhibitors;
        service.getInvoices                 = getInvoices;
        service.getPhysicalFairs            = getPhysicalFairs;
        service.getVirtualFairs             = getVirtualFairs;
        service.getWebinars                 = getWebinars;
        service.getEdupoints                = getEdupoints;
        service.getTargets                  = getTargets;
        service.notSoldBySeller             = notSoldBySeller;
        service.pendingInvoices             = pendingInvoices;
        service.getEventsPerformance        = getEventsPerformance;
        service.getSellerGoals              = getSellerGoals;
        service.getSellerGoalsSemesters     = getSellerGoalsSemesters;

        // /* STORE A NEW */
        function getExhibitors(query)
        {
            return $http.post(API_BASE + '/generalReport/clientHistory/getExhibitors',query)
                .then(function(response) {
                    return response.data;
                });
        }

        function getInvoices(query)
        {
            return $http.post(API_BASE + '/generalReport/clientHistory/getInvoices',query)
                .then(function(response) {
                    return response.data;
                });
        }

        function getPhysicalFairs(query)
        {
            return $http.post(API_BASE + '/generalReport/clientHistory/getPhysicalFairs',query)
                .then(function(response) {
                    return response.data;
                });
        }

        function getVirtualFairs(query)
        {
            return $http.post(API_BASE + '/generalReport/clientHistory/getVirtualFairs',query)
                .then(function(response) {
                    return response.data;
                });
        }

        function getWebinars(query)
        {
            return $http.post(API_BASE + '/generalReport/clientHistory/getWebinars',query)
                .then(function(response) {
                    return response.data;
                });
        }

        function getEdupoints(query)
        {
            return $http.post(API_BASE + '/generalReport/clientHistory/getEdupoints',query)
                .then(function(response) {
                    return response.data;
                });
        }

        function getTargets(query)
        {
            return $http.get(API_BASE + '/generalReport/targets',{params:query})
                .then(function(response) {
                    return response.data;
                }, function myError(response) {
                    console.log(response);
                });
        }

        function notSoldBySeller(query)
        {
            return $http.get(API_BASE + '/generalReport/notsoldbyseller', {params: query});
        }

        function pendingInvoices(query)
        {
            return $http.get(API_BASE + '/generalReport/pending-invoices', {params: query});
        }

        // function list (query)
        // {
        //     return $http.get(API_BASE + '/news/list',{params:query});
        // }
        //
        // function getNew(id)
        // {
        //     return $http.get(API_BASE + '/news/' + id);
        // }
        //
        // function updateNew(id,data)
        // {
        //     return $http.post(API_BASE + '/news/update/' + id, data)
        //         .then(function(response) {
        //             return response.data;
        //         });
        // }
        // function deleteNew(id)
        // {
        //     return $http.get(API_BASE + '/news/delete/' + id)
        //         .then(function(response) {
        //             return response.data;
        //         });
        // }

        function getEventsPerformance(query)
        {
            return $http.get(API_BASE + '/generalReport/events-performance', {params: query});
        }

        function getSellerGoals(query)
        {
            return $http.get(API_BASE + '/generalReport/seller-goals', {params: query});
        }

        function getSellerGoalsSemesters(query)
        {
            return $http.get(API_BASE + '/generalReport/seller-goals/semesters', {params: query});
        }

    }
})();